export default __webpack_public_path__ + "static/media/consultancy.687dfb6f.png";